import { sortBy } from 'lodash-es';
import { isFuture } from 'utils/date-fns/index.js';
import { dateString } from 'utils/timeFormat.js';
import { idValues } from 'utils/arrays.js';
import { fixEndForCalendar } from 'utils/eventTimes.js';
import mergeBlocks from './mergeBlocks.js';

function getEvents({ currentSet, sets, student, meetingId, dates }) {
  const currentStudents = idValues(currentSet.meetings).map((meeting) => meeting.studentId);
  const eventsBySetStudent = {};
  idValues(sets)
    .filter((set) => isFuture(set.end))
    .map(mergeBlocks)
    .forEach((set) => {
      idValues(set.meetings).forEach((meeting) => {
        idValues(set.blocks)
          .filter((block) => dates.includes(dateString(block.start)))
          .map((block) => ({
            ...block,
            set,
            meeting,
            student: meeting.details.student,
          }))
          .forEach((event) => {
            const key = `${meeting.studentId}|${set.id}|${event.concurrent}`;
            const current = eventsBySetStudent[key];
            eventsBySetStudent[key] = [...(current || []), event];
          });
      });
    });
  const columns = sortBy(Object.values(eventsBySetStudent), (ev) => {
    const { id, displayName } = ev[0].student;
    const setId = ev[0].set.id;
    return [
      id !== student.userId,
      !currentStudents.includes(id),
      displayName,
      setId !== meetingId,
      setId,
    ];
  }).map((col, idx) => col.map((ev) => ({
    ...ev,
    offset: idx,
    slotsAvailable: ev.timeslots.filter((slot) => slot.available).length,
  })));
  const columnStudents = columns.map((col) => ({
    ...col[0].student,
    offset: col[0].offset,
    concurrent: col[0].concurrent,
    meeting: col[0].meeting,
  }));
  const events = columns.flat().map(fixEndForCalendar);
  return { columnStudents, events };
}

export default getEvents;
